module.exports = __webpack_public_path__ + "img/9788956607108.8ff52626.jpg";